<template>
  <div class="agreement-page">
    <div class="title">资质与协议</div>
    <div class="agreement-box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="隐私协议" name="1">隐私协议</el-tab-pane>
        <el-tab-pane label="用户协议" name="2">用户协议</el-tab-pane>
        <el-tab-pane label="免责声明" name="3">免责声明</el-tab-pane>
        <el-tab-pane label="平台资质" name="4">平台资质</el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import * as api from '@/services';

export default {
  components: {},
  mounted() {},
  methods: {
    handleClick(tab, event) {}
  },
  data() {
    return {
      activeName: '1'
    };
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__nav-wrap::after {
  height: 0;
}
.agreement-page {
  min-height: 539px;
  background-color: #ffffff;
  .title {
    padding-left: 24px;
    height: 42px;
    border-bottom: 1px solid #eeeeee;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
  }
  .agreement-box {
    display: flex;
    flex-wrap: wrap;
    padding-left: 16px;
  }
}
</style>
